import { Card, Stack, Text, ThemeIcon, Title } from '@mantine/core'
import { IconRocket } from '@tabler/icons-react'

interface ComingSoonProps {
  title: string
  description?: string
}

export function ComingSoon({ title, description }: ComingSoonProps) {
  return (
    <Card shadow="sm" withBorder p="xl">
      <Stack align="center" justify="center" gap="lg" py="xl">
        <ThemeIcon size={80} radius="xl" color="prism" variant="light">
          <IconRocket size={40} />
        </ThemeIcon>
        <Stack gap={4} align="center">
          <Title order={1} c="gray.9" ta="center">
            {title}
          </Title>
          <Text c="gray.6" ta="center" maw={480}>
            {description ?? `${title} is coming soon.`}
          </Text>
        </Stack>
      </Stack>
    </Card>
  )
}
